export default "__VITE_ASSET__0ac5d731__"